import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Printer } from "lucide-react";
import { useBusinessInfo } from "@/contexts/BusinessInfoContext";

export default function Footer() {
  const { info } = useBusinessInfo();
  const cityCountry = [info.city, info.country].filter(Boolean).join(", ");
  return (
    <footer className="bg-[#0A0A0A] text-white mt-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12 grid md:grid-cols-4 gap-8">
        <div>
          <div className="flex items-center gap-2 mb-4">
            <div className="w-9 h-9 bg-[#059669] flex items-center justify-center">
              <Printer className="w-5 h-5 text-white" strokeWidth={2.5} />
            </div>
            <div className="font-display font-black text-xl">{(info.name || "CTP Kenya").toUpperCase()}</div>
          </div>
          <p className="text-sm text-white/70 leading-relaxed">
            {info.tagline}<br />
            Nairobi&apos;s fastest print-on-demand for students, professionals & small businesses.
          </p>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] font-bold mb-4 text-white/60">Services</h4>
          <ul className="space-y-2 text-sm">
            <li>Black & White Printing</li>
            <li>Color Printing</li>
            <li>Binding & Stapling</li>
            <li>Lamination</li>
            <li>Bulk Orders</li>
          </ul>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] font-bold mb-4 text-white/60">Quick Links</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/order" className="hover:text-[#059669]">New Order</Link></li>
            <li><Link to="/track" className="hover:text-[#059669]">Track Order</Link></li>
            <li><Link to="/visit" className="hover:text-[#059669]" data-testid="footer-visit-link">Visit the shop</Link></li>
            <li><Link to="/login" className="hover:text-[#059669]">Login</Link></li>
            <li><Link to="/signup" className="hover:text-[#059669]">Sign up</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] font-bold mb-4 text-white/60">Contact</h4>
          <ul className="space-y-2 text-sm">
            {cityCountry && (
              <li className="flex items-start gap-2"><MapPin className="w-4 h-4 mt-0.5 text-[#059669]" /> {cityCountry}</li>
            )}
            {info.phone && (
              <li className="flex items-start gap-2"><Phone className="w-4 h-4 mt-0.5 text-[#059669]" /> <a href={`tel:${info.phone.replace(/\s/g, "")}`} className="hover:text-[#059669]" data-testid="footer-phone">{info.phone}</a></li>
            )}
            {info.email && (
              <li className="flex items-start gap-2"><Mail className="w-4 h-4 mt-0.5 text-[#059669]" /> <a href={`mailto:${info.email}`} className="hover:text-[#059669]" data-testid="footer-email">{info.email}</a></li>
            )}
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-4 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-white/50">
          <div>© {new Date().getFullYear()} {info.name || "CTP Kenya"}. All rights reserved.</div>
          <div className="flex items-center gap-4 flex-wrap">
            <Link to="/how-it-works" className="hover:text-[#059669]" data-testid="footer-how-it-works-link">
              How it works
            </Link>
            <Link to="/terms" className="hover:text-[#059669]" data-testid="footer-terms-link">
              Terms &amp; Conditions
            </Link>
            <span className="uppercase tracking-[0.2em]">Pay with M-Pesa · Pickup in {info.city || "Nairobi"} · Countrywide courier delivery</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
